import GuidUtils from '@/shared/utils/guid'

export default class PhysiologyModel {
  constructor({
    id,
    classId,
    name,
    season,
    teacherId,
    jumpLiterature,
    sprintLiterature,
    yoyoLiterature,
    jumpLiteratureName,
    sprintLiteratureName,
    yoyoLiteratureName,
    studentsIds
  } = {}) {
    this.id = id || GuidUtils.emptyGuid,
    this.classId = classId
    this.name = name
    this.season = season
    this.teacherId = teacherId
    this.jumpLiterature = jumpLiterature
    this.sprintLiterature = sprintLiterature
    this.yoyoLiterature = yoyoLiterature
    this.jumpLiteratureName = jumpLiteratureName
    this.sprintLiteratureName = sprintLiteratureName
    this.yoyoLiteratureName = yoyoLiteratureName
    this.studentsIds = studentsIds
  }
}